import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from './../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { saloon1ImageOptions } from './views/saloon1'

class X43Saloon extends Component {
    constructor(props) {
        super(props);
        this.handleCupboardsSaloonChange = this.handleCupboardsSaloonChange.bind(this);
    }


    handleCupboardsSaloonChange(event) {
        let configuration = this.props.configuration;
        configuration.CupboardsSaloon = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloon1ImageOptions;

        let image = <ConfiguratorImage boat="X4_3" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>

                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>
                    <p><Trans defaults='You can choose to have extra storage space by adding upper cupboards in the saloon.' /></p>
                    <p><Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint - and if optional upper cupboards are selected, the lighting is fitted below the cupboards.' /></p>

                    <Toggle checked={this.props.configuration.CupboardsSaloon.value === 2} onChange={this.handleCupboardsSaloonChange}>
                        <Trans defaults='Upper cupboards' />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X43Saloon);


// WEBPACK FOOTER //
// ./src/X43/X43Saloon.js